export default {
  toCartQuantity: 1
};



/** WEBPACK FOOTER **
 ** ./src/components/Cart/redux/cartState.js
 **/